export const imagenRequest = async ({ prompt, images, assistantId }) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_FIREBASE_CLOUD_FUNCTIONS_URL}/imagen`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt: prompt, images: images, assistantId: assistantId }),
      }
    );

    if (!response.ok) {
      throw new Error("Error with the image request");
    }

    const data = await response.text(); // Use .text() for plain text response
    console.log(data); // Logs the plain text response

    return data; // Return the plain text for further use
  } catch (error) {
    
    throw new Error("Error with the image request");
  }
};
